import type { LunyaMascotPose } from './types'

/**
 * Поза → изображение маскота (apps/web/public/images). Единственная точка подмены: код позы
 * не касается, компоненты просят `pose`, а не путь.
 *
 * `FULL_BOWL` ждёт свой арт и пока показывает базовую позу — она нейтральна и в кадре
 * «сытой Луни» не выглядит ошибкой.
 */
export const MASCOT_POSE_IMAGE: Record<LunyaMascotPose, string> = {
  BASE: '/images/lunya.png',
  TENDER: '/images/lunya-tender.png',
  CALLING: '/images/lunya-calling.png',
  ASKING: '/images/lunya-asking.png',
  FULL_BOWL: '/images/lunya.png',
  BOWL: '/images/lunya-bowl.png',
  PAIR: '/images/lunya-pair.png',
}
